<div class="booking animate-fade-in">

  <!--  Stepper  -->
  <div class="stepper stagger-1">
    <div class="stepper__step" [class.stepper__step--done]="!!selectedProfessional">
      <div class="stepper__dot">
        <span class="material-symbols-outlined" *ngIf="!!selectedProfessional">check</span>
        <span *ngIf="!selectedProfessional">1</span>
      </div>
      <span class="stepper__label">Profesional</span>
    </div>
    <div class="stepper__line"></div>
    <div class="stepper__step" [class.stepper__step--active]="!!selectedProfessional && !selectedDate"
                               [class.stepper__step--done]="!!selectedDate">
      <div class="stepper__dot">
        <span class="material-symbols-outlined" *ngIf="!!selectedDate">check</span>
        <span *ngIf="!selectedDate">2</span>
      </div>
      <span class="stepper__label">Fecha</span>
    </div>
    <div class="stepper__line"></div>
    <div class="stepper__step" [class.stepper__step--active]="!!selectedDate && !selectedTime"
                               [class.stepper__step--done]="!!selectedTime">
      <div class="stepper__dot">
        <span class="material-symbols-outlined" *ngIf="!!selectedTime">check</span>
        <span *ngIf="!selectedTime">3</span>
      </div>
      <span class="stepper__label">Horario</span>
    </div>
    <div class="stepper__line"></div>
    <div class="stepper__step" [class.stepper__step--active]="!!selectedTime">
      <div class="stepper__dot">4</div>
      <span class="stepper__label">Confirmar</span>
    </div>
  </div>

  <!--  Banner reprogramación  -->
  <div class="reschedule-banner" *ngIf="reschedulingId">
    <span class="material-symbols-outlined">edit_calendar</span>
    <p>Estás <strong>reprogramando</strong> un turno existente. El turno anterior será cancelado al confirmar.</p>
  </div>

  <!--  Header  -->
  <div class="booking-header stagger-2">
    <div class="booking-header__text">
      <h1>{{ reschedulingId ? 'Reprogramar turno' : 'Reservar turno' }}</h1>
      <p>Elegí el día y horario que mejor te quede.</p>
    </div>
  </div>

  <!--  Professional selector  -->
  <section class="booking-section stagger-2" *ngIf="professionals.length > 1">
    <h2 class="section-label">
      <span class="material-symbols-outlined">groups</span>
      Profesional
    </h2>
    <div class="professional-grid">
      <button
        *ngFor="let pro of professionals"
        class="professional-card"
        [class.professional-card--selected]="selectedProfessional.id === pro.id"
        (click)="selectProfessional(pro)"
      >
        <div class="professional-card__avatar">
          <span class="material-symbols-outlined">person</span>
        </div>
        <div class="professional-card__info">
          <span class="professional-card__name">{{ pro.name }}</span>
          <span class="professional-card__specialty">{{ pro.specialty }}</span>
        </div>
      </button>
    </div>
  </section>

  <!--  Service selector  -->
  <section class="booking-section stagger-3">
    <h2 class="section-label">
      <span class="material-symbols-outlined">medical_services</span>
      Tipo de servicio
    </h2>
    <div class="service-grid">
      <button
        *ngFor="let svc of serviceTypes"
        class="service-card"
        [class.service-card--selected]="selectedService.label === svc.label"
        (click)="selectService(svc)"
      >
        <span class="service-name">{{ svc.label }}</span>
        <span class="service-duration">{{ svc.duration }} min</span>
      </button>
    </div>
  </section>

  <!--  Date picker  -->
  <section class="booking-section stagger-3" [class.booking-section--error]="dateError">
    <h2 class="section-label">
      <span class="material-symbols-outlined">calendar_month</span>
      Elegí una fecha
    </h2>
    <div class="date-scroll">
      <button
        *ngFor="let d of availableDates"
        class="date-chip"
        [class.date-chip--selected]="selectedDate === d"
        (click)="selectDate(d)"
      >
        {{ formatDate(d) }}
      </button>
    </div>
    <span class="validation-msg" *ngIf="dateError">
      <span class="material-symbols-outlined">error</span>
      Seleccioná una fecha antes de continuar.
    </span>
  </section>

  <!--  Time slots  -->
  <section class="booking-section stagger-4" *ngIf="selectedDate" [class.booking-section--error]="timeError">
    <h2 class="section-label">
      <span class="material-symbols-outlined">schedule</span>
      Horarios disponibles  <span class="section-label__date">{{ formatDateFull(selectedDate) }}</span>
    </h2>
    <div class="slots-grid">
      <button
        *ngFor="let slot of timeSlots"
        class="slot-btn"
        [class.slot-btn--selected]="selectedTime === slot.time"
        [class.slot-btn--taken]="!slot.available"
        [disabled]="!slot.available"
        (click)="selectTime(slot)"
      >
        {{ slot.time }}
        <span *ngIf="!slot.available" class="slot-taken-label">Ocupado</span>
      </button>
    </div>
    <span class="validation-msg" *ngIf="timeError">
      <span class="material-symbols-outlined">error</span>
      Seleccioná un horario disponible.
    </span>
  </section>

  <!--  Notes  -->
  <section class="booking-section stagger-4" *ngIf="selectedTime">
    <h2 class="section-label">
      <span class="material-symbols-outlined">edit_note</span>
      Notas (opcional)
    </h2>
    <textarea
      class="input-field notes-field"
      rows="3"
      placeholder="Describ� brevemente el motivo de tu consulta..."
      [(ngModel)]="notes"
    ></textarea>
  </section>

  <!--  Summary + Submit  -->
  <section class="booking-summary stagger-5" *ngIf="selectedTime">
    <div class="summary-card">
      <div class="summary-row">
        <span class="material-symbols-outlined">event</span>
        <div>
          <span class="summary-label">Fecha</span>
          <span class="summary-value">{{ formatDateFull(selectedDate) }}</span>
        </div>
      </div>
      <div class="summary-row">
        <span class="material-symbols-outlined">schedule</span>
        <div>
          <span class="summary-label">Hora</span>
          <span class="summary-value">{{ selectedTime }} hs</span>
        </div>
      </div>
      <div class="summary-row">
        <span class="material-symbols-outlined">medical_services</span>
        <div>
          <span class="summary-label">Servicio</span>
          <span class="summary-value">{{ selectedService.label }}</span>
        </div>
      </div>
      <div class="summary-row">
        <span class="material-symbols-outlined">person</span>
        <div>
          <span class="summary-label">Profesional</span>
          <span class="summary-value">{{ selectedProfessional.name }}</span>
        </div>
      </div>
      <div class="summary-row" *ngIf="selectedService.price">
        <span class="material-symbols-outlined">payments</span>
        <div>
          <span class="summary-label">Total</span>
          <span class="summary-value summary-value--price">$ {{ selectedService.price | number:'1.0-0' }}</span>
        </div>
      </div>
    </div>

    <div *ngIf="error" class="booking-error">
      <span class="material-symbols-outlined">error</span>
      {{ error }}
    </div>

    <button
      class="btn-primary booking-submit"
      [disabled]="!canSubmit"
      (click)="submit()"
    >
      <span *ngIf="!isLoading">
        <span class="material-symbols-outlined">payment</span>
        {{ reschedulingId ? 'Reprogramar y pagar' : 'Continuar al pago' }}
      </span>
      <span *ngIf="isLoading" class="spinner"></span>
    </button>

    <p class="booking-trust">
      <span class="material-symbols-outlined">lock</span>
      Pago seguro procesado por MercadoPago.
    </p>
  </section>

</div>

<!-- MercadoPago payment overlay -->
<div class="mp-overlay" *ngIf="showPayment" (click)="cancelPayment()">
  <div class="mp-sheet" (click)="$event.stopPropagation()">
    <div class="mp-header">
      <span class="mp-logo-text">mercadopago</span>
      <button class="mp-close" (click)="cancelPayment()" aria-label="Cerrar">
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>

    <div class="mp-summary">
      <h3>Resumen del pago</h3>
      <div class="mp-row">
        <span>{{ selectedService.label }}</span>
        <strong>$ {{ selectedService.price | number:'1.0-0' }}</strong>
      </div>
      <div class="mp-row mp-row--total">
        <span>Total</span>
        <strong>$ {{ selectedService.price | number:'1.0-0' }} ARS</strong>
      </div>
    </div>

    <div class="mp-form">
      <label class="mp-field">
        <span>Número de tarjeta</span>
        <input type="text" placeholder="4111 1111 1111 1111" maxlength="19" />
      </label>
      <div class="mp-row-fields">
        <label class="mp-field">
          <span>Vencimiento</span>
          <input type="text" placeholder="MM/AA" maxlength="5" />
        </label>
        <label class="mp-field">
          <span>CVV</span>
          <input type="text" placeholder="123" maxlength="3" />
        </label>
      </div>
      <label class="mp-field">
        <span>Nombre del titular</span>
        <input type="text" placeholder="Como figura en la tarjeta" />
      </label>
    </div>

    <button class="mp-pay-btn" (click)="confirmPayment()" [disabled]="paymentProcessing">
      <span *ngIf="!paymentProcessing">
        <span class="material-symbols-outlined">lock</span>
        Pagar $ {{ selectedService.price | number:'1.0-0' }}
      </span>
      <span *ngIf="paymentProcessing" class="spinner"></span>
    </button>

    <p class="mp-secure">
      <span class="material-symbols-outlined">verified_user</span>
      Transacción protegida con cifrado SSL
    </p>
  </div>
</div>
